import { getTeamsDateFormat, getTeamsTimeFormat } from "../utils/dateUtils";

const pl = {
    common: {
        loader: "Trwa wczytywanie danych...",
        meetingCancelled: "Spotkanie zostało anulowane",
    },
    logo: {
        corporation: "Logo mBank dla korporacji",
        retail: "Logo mBank dla klientów detalicznych",
        private: "Logo mBank dla private banking",
    },
    requestCancelMeeting: {
        actionButton: "Wyślij prośbę",
        pendingDescription: (startAt: Date) =>
            `Czy chcesz wysłać do organizatora prośbę o anulowanie spotkania
            z dnia ${getTeamsDateFormat(startAt)}r. o godzinie ${getTeamsTimeFormat(startAt)}?`,
        inProgressDescription: (startAt: Date) =>
            `Spotkanie ${getTeamsDateFormat(startAt)}r. o godzinie ${getTeamsTimeFormat(
                startAt
            )} już trwa lub zaraz się rozpocznie.
        Jego anulowanie nie jest już możliwe. W razie konieczności odwołania spotkania skontaktuj się ze swoim doradcą.`,
        expiredDescription: (endAt: Date) =>
            `Spotkanie zakończyło się ${getTeamsDateFormat(endAt)}r. o godzinie ${getTeamsTimeFormat(
                endAt
            )}.\nAnulowanie nie jest już możliwe.`,
        requestSent:
            "Prośba o anulowanie spotkania została przesłana. Twój doradca wkrótce skontaktuje się z Tobą w celu potwierdzenia anulowania.",
        redirectButton: "Nie wysyłaj",
    },
    joinMeeting: {
        meetingNotFound:
            "Nie znaleziono spotkania. Być może link jest niepoprawny. Sprawdź jego poprawność i spróbuj ponownie.",
        actionButton: "Rozpocznij spotkanie",
        redirectButton: "Anuluj spotkanie",
        pendingDescription: (startAt: Date) =>
            `Spotkanie rozpocznie się ${getTeamsDateFormat(startAt)}r. o godzinie ${getTeamsTimeFormat(
                startAt
            )}.\nDołączenie będzie możliwe na 10 minut przed rozpoczęciem.`,
        inProgressDescription:
            'Zaraz rozpocznie się spotkanie, które będzie nagrywane.\nJeśli nie wyrażasz zgody, kliknij przycisk "Anuluj spotkanie"',
        expiredDescription: (endAt: Date) =>
            `Spotkanie zakończyło się ${getTeamsDateFormat(endAt)}r. o godzinie ${getTeamsTimeFormat(
                endAt
            )}.\nDołączenie nie jest już możliwe.`,
        wrongAddress:
            "Adres spotkania jest nieprawidłowy. Sprawdź czy adres w przeglądarce jest tym, który został wysłany w wiadomości email.",
        failedToJoin:
            "Nie udało sie dołączyć do spotkania. Być może link jest niepoprawny. Sprawdź jego poprawność i spróbuj ponownie.",
        browserUnsupportedError: (recommendedBrowsers: string) =>
            `Korzystasz z niewspieranej przeglądarki. Rekomendujemy skorzystanie z najnowszej wersji jednej z następujących przeglądarek: ${recommendedBrowsers}`,
    },
};

export default pl;
